import { Component, Input } from '@angular/core';
import { FundId } from '@types';
import { Benchmark } from '../statistics-and-positions.component';

export interface StatisticRow {
  label: string;
  val: string;
  bmVal?: string;
  caveatPlacement?: string;
  secondaryCaveatPlacement?: string;
  tooltip?: string;
  asOfLabel?: string;
  asOfDate?: string;
  updateFrequency?: string;
}

@Component({
  selector: 'ft-benchmark-table',
  templateUrl: './benchmark-table.component.html',
  styleUrls: ['./benchmark-table.component.scss'],
})
export class BenchmarkTableComponent {
  @Input() fundId: FundId;
  @Input() benchmark: Benchmark;
  @Input() rows: StatisticRow[];
}
